export default __webpack_public_path__ + "static/media/6.116e9c1a.png";